 <template>

<router-link :title="this.$root.trans.create" class="btn-creative btn-3 btn-3e flaticon-plus" :to="{name: routeName}">
    
    <span>إضافة جديد</span> </router-link>
</template>

<script>
    import baseApi from '@/baseApi'
    export default {
        components: {
        },
        props: {
            routeName: String,
        },
        data () {
            return {
            }
        },
        computed:{
        },
        mounted() {

        },
        methods: {

		},
        watch: {

        },
    }
</script>




